import { SearchableAnalysisInDecision, SearchableDecisionInstantSearch } from '@livv/models';
import { Hit } from 'instantsearch.js';
import { FC } from 'react';
import ClickablePath from '@components/search/preview/ContentCard/ClickablePath';
import { getDisplayableAnalysesInDecisionPathItems } from '@utils/search/previews';

interface AnalysisPathTitleProps {
    analysis: SearchableAnalysisInDecision;
    hit: Hit<SearchableDecisionInstantSearch>;
}

const MAX_ANALYSIS_PATHS = 3;

const AnalysisPathTitle: FC<AnalysisPathTitleProps> = ({ analysis, hit }) => {
    const { baseObjectID } = analysis;
    const displayedAnalysisPaths = getDisplayableAnalysesInDecisionPathItems(
        analysis,
        hit,
        MAX_ANALYSIS_PATHS,
    );

    if (!displayedAnalysisPaths.length) {
        return null;
    }

    return (
        <ClickablePath
            hitId={baseObjectID}
            overrideContainerBoxSx={{
                maxWidth: '90vw',
                mb: 0.2,
                my: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            }}
            paths={displayedAnalysisPaths}
        />
    );
};

export default AnalysisPathTitle;
